module.exports = __webpack_public_path__ + "img/newsImg11-8.0adfbffa.png";